// extracted by mini-css-extract-plugin
export default {"propertyReadOnly":"ttuZu","value":"YYhFS","icon":"cioaV"};